import { jsonrepair } from 'jsonrepair';

import { sanitizeStreamContentForADFStreamer } from './utils';

export class JsonRepair {
	private buffer = '';
	private prevSize = 0;

	constructor() {}

	public append(chunk: string): void {
		this.buffer += chunk;
	}

	/**
	 * parse will actually repair the json string stored in buffer.
	 * It will throw error if it fails to repair the json string.
	 * It will return the repaired json string if it succeeds and
	 * 	also indicate if the json string has changed.
	 */
	public parse(): { hasChanged: boolean; repairedJson: object } {
		const sanitizedBuffer = sanitizeStreamContentForADFStreamer(this.buffer);
		const repairedJsonString = jsonrepair(sanitizedBuffer);

		if (repairedJsonString?.length) {
			try {
				const repairedJson: object = JSON.parse(repairedJsonString);

				const size = repairedJsonString.length;
				const hasChanged = size !== this.prevSize;
				this.prevSize = size;

				return { hasChanged, repairedJson };
			} catch (error) {
				/**
				 * If it comes here, it means JSON.parse failed.
				 * Ideally, it should not happen, but if there is a bug in the jsonrepair function,
				 * 	then it can return invalid json string.
				 * We want to capture that, so throwing specific error here.
				 */
				throw new Error('failed to parse repaired json string returned by jsonrepair.');
			}
		} else {
			throw new Error('jsonrepair returned undefined or empty string.');
		}
	}

	public reset(): void {
		this.buffer = '';
		this.prevSize = 0;
	}
}
